import { Component, Inject, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ProductDetailsMainSlider } from 'src/app/models/product-details-main-slider';
import { ProductDetailsThumbSlider } from 'src/app/models/product-details-thumb-slider';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'calsoft-img-preview',
  templateUrl: './img-preview.component.html',
  styleUrls: ['./img-preview.component.scss'],
  encapsulation: ViewEncapsulation.None

})
export class ImgPreviewComponent implements OnInit {
  commonImageApi=environment.commonImageApiNew;
  public ProductDetailsThumbConfig: any = ProductDetailsThumbSlider;
  public ProductDetailsMainSliderConfig: any = ProductDetailsMainSlider;
  public activeSlide: any = 0;
  @ViewChild('slideshow',{static:true}) slideshow: any;
  data:any=[];
  private bigImage = environment.ImageAPI1;
  image: any;
  img: any;
  imageSources: string;
  productDetailHeightMobile: any="-webkit-fill-available";
  productDetailWidthMobile: any="-webkit-fill-available";
  index: number;
  total: any;

  public serverPath7 = environment.commonImageApi+"catalog/product";


  constructor(
    @Inject(MAT_DIALOG_DATA) data,
    private dialog:MatDialog,
  ) {
    this.data=data.images;
    this.index=data.page;

    this.imageSources = this.bigImage + this.data;
 
  this.total=this.data.length -2;

  }

  imgUrl:any=[];

  ngOnInit() {
  
    if(this.data.length==1){
      this.slideConfig.touchDrag=false;
      this.slideConfig.mouseDrag=false;
      this.slideConfig.dots=false;
      }

  }

close(){
this.dialog.closeAll();
}

left(){
  this.index --
}
right(){
  this.index ++
}

eventText = ''; 
onSwipe(evt) {

  const x = Math.abs(evt.deltaX) > 40 ? (evt.deltaX > 0 ? 'right' : 'left') : '';
  const y = Math.abs(evt.deltaY) > 40 ? (evt.deltaY > 0 ? 'down' : 'up') : '';

  if (this.eventText.includes("left")) {
    this.left();
       
  } else if (this.eventText.includes("right")) {
    this.right();
  

  }
}


slideConfig = {
  items: 1,
  nav: false,
  dots:true,
  autoplay: false,
  slideSpeed: 300,
  loop: true,
  mouseDrag: true,
  touchDrag: true,
};

afterChange(event){

  this.index=event.currentSlide
}


}
